import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ToastController } from 'ionic-angular';
import { CampaignsProvider }  from '@providers/campaigns/campaigns';
import { TranslateService } from '@ngx-translate/core';
import { AuthProvider } from '@providers/auth/auth';

@IonicPage()
@Component({
  selector: 'page-chage-password',
  templateUrl: 'chage-password.html',
})
export class ChagePasswordPage {

  campaign: any;
  nuevaContrasenia: string;
  confirmarContrasenia: string;
  jugador: any;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public campaignsProvider: CampaignsProvider,
    public alertCtrl: AlertController,
    public translate: TranslateService,
    private authProvider: AuthProvider,
    public toastCtrl: ToastController,
  ) {
  }

  async ionViewDidLoad() {
    this.jugador = await this.authProvider.getSession();
    this.campaign = await this.campaignsProvider.get();
  }

  close() {
    this.navCtrl.pop();
  }

  verificaContrasenias(message: string) {
    const alert = this.alertCtrl.create({
      title: '¡Error!',
      subTitle: message,
      buttons: ['OK']
    });
    alert.present();
  }

  cambiarContrasenia() {
    if(!this.nuevaContrasenia || this.nuevaContrasenia.length < 6) {
      this.verificaContrasenias(this.translate.instant('perfil.cambiarContrasenia.longitud'));
      return false;
    }

    if(this.nuevaContrasenia != this.confirmarContrasenia ) {
      this.verificaContrasenias(this.translate.instant('perfil.cambiarContrasenia.contrasenias'));
      return false;
    }

    this.authProvider.cambiaContrasenia(this.jugador._id, this.nuevaContrasenia)
      .then( response => {
        this.nuevaContrasenia = '';
        this.confirmarContrasenia = '';

        const toast = this.toastCtrl.create({
           message: this.translate.instant('perfil.cambiarContrasenia.ok'),
           duration: 4000,
           position: 'bottom'
        });
        toast.present();
      })
      .catch( e => {
        const alert = this.alertCtrl.create({
          title: '¡Error!',
          subTitle: e.error.message,
          buttons: ['OK']
        });
        alert.present();
      })
  }

}



// WEBPACK FOOTER //
// ./src/pages/chage-password/chage-password.ts